import fetch from "../../auth/FetchInterceptor";

export const updateBilling = function (data) {
  return fetch({
    url: '/billing',
    method: 'post',
    data: data
  })
}